class BaseMapper {
    static renameField = (object, currentName, newName) => {
        object[newName] = object[currentName];

        delete object[currentName];
    };

    static cloneObjectList = (list, callback) => {
        return list.map(item => {
            const clonedItem = new item.constructor(item);

            callback(clonedItem);

            return clonedItem;
        });
    };
}

export default BaseMapper;
